import { render, staticRenderFns } from "./client-service.vue?vue&type=template&id=e3749baa&scoped=true&"
import script from "./client-service.vue?vue&type=script&lang=js&"
export * from "./client-service.vue?vue&type=script&lang=js&"
import style0 from "./client-service.vue?vue&type=style&index=0&id=e3749baa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3749baa",
  null
  
)

export default component.exports